"use client";

import { type ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Snackbar
import { SnackbarProvider } from "notistack";

export default function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 1000,
          },
        },
      }),
  )

  return (
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <QueryClientProvider client={queryClient}>
            {children}
          {<ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </SnackbarProvider>
  );
}
